export const Settings = {
	apiUrl: 'https://wscmsapi.azurewebsites.net/',
	apiKey: 'V1NMMkNBZG1pbjpaUXUzNlNldWZaOEhhSkc=',
	appVersion: '3.0'
};
